import { HOME_TOUR_TRANSLATIONS } from "./home-tour-translations.ts"
import { RO_MAIN_TRANSLATIONS } from "./main-translations.ts"
import { REPORTS_NAMESPACE_TRANSLATIONS } from "./reports-namespace-translations.ts"
import { REPORTS_TRANSLATIONS } from "./reports-translations.ts"
import { COW_STATUS_TRANSLATIONS } from "@/locales/ro/cow-status-translations.ts"

export const RO_TRANSLATIONS = {
  translation: {
    ...RO_MAIN_TRANSLATIONS,
    ...REPORTS_TRANSLATIONS,
    homeTour: {
      ...HOME_TOUR_TRANSLATIONS,
    },
    cowStatus: { ...COW_STATUS_TRANSLATIONS },
  },
  reports: { ...REPORTS_NAMESPACE_TRANSLATIONS },
}
